function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON, Object, String) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['frequency-value'] = function(frequencyIdx) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const frequencyValue = $helpers.getFrequencyValue(frequencyIdx);
        const frequencyState = $helpers.getFrequencyState(frequencyIdx);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'cohorts-frequency-value': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: () => $helpers.clickedFrequencyLabel(frequencyIdx)
            },
            "class": {
              'cohorts-clause-clickable': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((frequencyState.isEditing) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-autoresizing-input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'focus': true,
                  'initial-width': frequencyState.initialInputWidth,
                  'input-style-overrides': JSON.stringify({
                    'font-size': `16px`,
                  }),
                  'placeholder': frequencyValue,
                }),
                "on": {
                  input: ev => $helpers.handleInput(ev, frequencyIdx),
                  change: ev => $helpers.changedFrequencyValue(ev, frequencyIdx),
                  focusout: () => $helpers.handleFocusout(frequencyIdx)
                },
                "props": {
                  value: frequencyState.inputText
                },
              }));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(frequencyValue);;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'cohorts-clause-frequencies': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(jade_mixins['frequency-value'].call(this, 0));
        __jade_nodes = __jade_nodes.concat(($helpers.shouldShowSecondFrequency()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cohorts-frequency-separator': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("and");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(jade_mixins['frequency-value'].call(this, 1));;
          return __jade_nodes
        }).call(this)) : undefined);
        const frequencyText = `${$helpers.pluralizedTimeLabel()},`;
        __jade_nodes = __jade_nodes.concat(($helpers.isDistinctDayEnabled()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cohorts-frequency-text': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: $helpers.clickedTimeLabel
              },
              "class": {
                'cohorts-clause-clickable': true
              },
            }, [__vjadeSafeCode(frequencyText)]));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cohorts-clause-builder-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat($component.child(`cohorts-builder-pane-dropdown`, {
                attrs: {
                  open: $helpers.isBehaviorCountTypeBuilderOpen()
                },
                on: {
                  'selected-behavior-count-type': $helpers.selectedBehaviorCountType,
                  'user-id': $attr(`user-id`)
                }
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cohorts-frequency-separator': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(frequencyText)]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;